<div class="privacy-policy">
  <div class="privacy-policy__container">
    <img [src]="'assets/acc-auth0.jpg'" class="acc-logo" alt="ACC Logo" />
    <h1 class="privacy-policy__title">ACC DATA HUB PRIVACY POLICY</h1>

    <div class="privacy-policy__effective-date">
      Effective Date: May 22, 2025
    </div>

    <div class="privacy-policy__section">
      <p>
        This Privacy Policy describes the data protection practices of
        Appalachian Community Capital Corporation ("ACC," "we," "us," or "our")
        in relation to the information we collect and use about you when you
        access ACC's Data Hub via accdata.org.
      </p>
    </div>

    <div class="privacy-policy__notice">
      <p>
        PLEASE READ THIS PRIVACY POLICY CAREFULLY TO UNDERSTAND HOW WE HANDLE
        YOUR INFORMATION. IF YOU DO NOT AGREE TO THIS PRIVACY POLICY, PLEASE DO
        NOT ACCESS ACC's DATA HUB. BY ACCESSING OR USING ACC'S DATA HUB, YOU
        AGREE TO THIS PRIVACY POLICY. THIS POLICY MAY CHANGE FROM TIME TO TIME
        (SEE NOTICE AND REVISIONS SECTION BELOW). YOUR CONTINUED USE OF ACC'S
        DATA HUB AFTER WE MAKE CHANGES IS DEEMED TO BE ACCEPTANCE OF THOSE
        CHANGES, SO PLEASE CHECK THE POLICY FREQUENTLY FOR UPDATES.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>OUR POLICY TOWARDS CHILDREN</h2>
      <p>
        ACC's Data Hub is not directed to persons under 16 and ACC does not
        knowingly collect or solicit personal information from children or
        knowingly allow such persons to register. If you are under 16, please do
        not attempt to register for ACC's Data Hub or send any information about
        yourself to us, including your name, address, telephone number, or email
        address. No one under the age of 16 may provide any personal information
        to or on ACC's Data Hub. In the event that we learn that we have
        collected personal information from a child under the age of 16 without
        verification of parental consent, we will delete that information as
        quickly as possible. If you become aware that a child has provided us
        with personal information without appropriate consent, then please
        contact us using the details below so that we can take the appropriate
        steps in accordance with our legal obligations and this Privacy Policy.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>THE INFORMATION THAT WE COLLECT</h2>
      <p>
        When you visit ACC's Data Hub, you provide us with two types of
        information: (1) usage information that is collected by us as you
        interact with the Data Hub, and (2) personal information that you
        knowingly choose to disclose.
      </p>

      <h3>Automatic Data Collection.</h3>
      <p>
        <strong>Cookies and Web Logs.</strong> When you enter the Website as a
        visitor, we may collect your browser type and IP address. The Data Hub
        utilizes tools for analytical purposes that might track these items. In
        addition, we may store certain information from your browser using
        "cookies." A cookie is a data file containing a string of characters
        that uniquely identifies your browser and is stored on your computer. We
        may use cookies to improve the quality of our service by storing user
        preferences, personalization features and other information about the
        user. You can remove or block cookies using the settings in your browser
        if you want to disable this convenience feature. In addition, our web
        logs automatically record information that your browser sends whenever
        you visit a website. These web server logs may include information such
        as the URL of the web page you have requested, your IP address, your
        browser type, your browser language, the date and time of your request
        to be served a certain page and one or more cookies that may uniquely
        identify your browser. We may also record information about the URL from
        which you came to the Website if the associated website contained a
        direct link to the Website.
      </p>
      <p>
        <strong>Web Beacons.</strong> Pages of our Website may contain small
        electronic files known as web beacons (also referred to as clear gifs,
        pixel tags, and single-pixel gifs) that permit ACC, for example, to
        count users who have visited those pages or for other related website
        statistics (for example, recording the popularity of certain website
        content and verifying system and server integrity).
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>ACC Data Hub User Information</h2>
      <p>
        When your organization subscribes to access ACC's Data Hub and take
        advantage of the resources available, your organization will provide
        certain personal information for its employees that will be users of the
        Data Hub, that are requested as part of the registration process, such
        as employees' names and email addresses, the company name, physical
        address and telephone number. Please note this information cannot be
        removed without deleting the user account.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>HOW WE USE YOUR INFORMATION</h2>
      <p>
        Information in your Data Hub profile that you or your organization
        chooses to include is used only by ACC for its own internal purposes and
        to optimize your experience in using ACC's Data Hub. You always have the
        ability to opt out of receiving communications relating to ACC's Data
        Hub by clicking the opt-out link included in the communications.
      </p>
      <p>
        ACC may use information about you or your movement or activities within
        the Data Hub in an anonymous, aggregate manner that does not disclose
        your identity or any personally identifiable information for purposes of
        determining how the Data Hub is being used and improving the Data Hub's
        content and/or performance.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>DISCLOSURE OF INFORMATION</h2>
      <p>
        We will not share your personal information with any third parties
        except as described in this Privacy Policy. ACC also does not sell your
        personal information with third parties for marketing, sales or other
        purposes. ACC shares your information with third parties only in the
        limited circumstances described below, in which ACC believes that such
        disclosure is reasonably necessary to provide a service, is legally
        required or is permitted by you.
      </p>
      <p>
        ACC may provide information to ACC's own employees and service providers
        to help us operate the Data Hub. This type of sharing may include
        disclosures to third parties who host the Data Hub, help deliver e-mail
        updates or otherwise provide back-end services. These providers will
        only be able to use such information subject to ACC's rights to do so
        and only for the purposes of performing the services that ACC contracts
        with them to provide on ACC's behalf.
      </p>
      <p>
        ACC may be required to disclose personal information pursuant to lawful
        requests, such as subpoenas or court orders, or in compliance with
        applicable laws. We do not reveal information unless we have a good
        faith belief that an information request by law enforcement or private
        litigants meets applicable legal standards.
      </p>
      <p>
        We may share personal information when we believe it is necessary to
        comply with law, to protect our interests or property, to prevent fraud
        or other illegal activity perpetrated through the Website, or to prevent
        imminent harm to any person or group of people. This may include sharing
        information with other companies, lawyers, agents or government
        agencies.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>STORING AND TRANSFERRING YOUR PERSONAL INFORMATION</h2>
      <h3>SECURITY</h3>
      <p>
        ACC is committed to protecting the security of your personal
        information. We proxy all web traffic through Cloudflare using TLS1.2
        encrypted traffic; have geoIP restricted access to ACC Data Hub user
        accounts; store all data on encrypted-at-rest storage accounts; utilize
        TLS1.2 data movements; restrict access to HTTPS browsers; require that
        browsers must meet compliant updates; do not allow legacy systems;
        require that systems undergo regular access reviews; require that
        vendors use accdata.org accounts that can be restricted at any time; and
        ACC Data Hub subscribes to Zero Trust protocols, Microsoft CIS, for
        example.
      </p>
      <p>
        The safety and security of your information also depends on you. Your
        organization may provide you with log-in credentials for access to the
        Data Hub, and you are solely responsible for keeping the credentials
        confidential.
      </p>
      <p>
        Please keep in mind that no internet communication is ever completely
        secure or error-free. Although we do our best to protect your personal
        information, we cannot guarantee the security of your personal
        information transmitted to our Data Hub. Any transmission of personal
        information is at your own risk. We are not responsible for
        circumvention of any privacy settings or security measures contained on
        the Website or within the Data Hub.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>RETAINING PERSONAL INFORMATION</h2>
      <p>
        We will only retain personal information you directly provide us with
        for as long as necessary to fulfil the purposes you provided it for,
        including for the purposes of our legitimate business interests and
        satisfying any legal or reporting requirements. To determine the
        appropriate retention period for personal information, we consider the
        amount, nature, and sensitivity of the personal information, the
        potential risk of harm from unauthorized use or disclosure of your
        personal information, the purposes for which we process your personal
        information and the applicable legal requirements.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>PERSONAL INFORMATION WE RECEIVE FROM THIRD PARTIES</h2>
      <p>
        We may be provided with personal information by a third party as part of
        the service we provide through ACC's Data Hub. Please feel free to
        contact us should you discover your personal information being provided
        through the Data Hub and wish for us to correct or delete the personal
        information we have been provided with. We may be provided with your
        personal information by other parties, and if that is the case, please
        do contact us to make us aware so we can delete it again from our
        systems. We cannot ensure that we will be able to delete that
        information without your request, given the volume of information we are
        obtaining from third parties.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>YOUR RIGHTS IN RESPECT OF YOUR PERSONAL INFORMATION</h2>
      <p>
        Our goal is to only gather, collate and provide small business
        information and not the personal information of individuals. However,
        should we collect personal information about you, in accordance with
        applicable privacy law, you have the following rights in respect of your
        personal information that we hold:
      </p>
      <ul>
        <li>
          <strong>Right of access and transferability.</strong> The right to
          obtain access to your personal information along with certain
          information, and to receive that personal information in a commonly
          used format and to have it transported to another data controller.
        </li>
        <li>
          <strong>Right to rectification.</strong> The right to obtain
          rectification of your personal information without undue delay where
          that personal information is inaccurate or incomplete.
        </li>
        <li>
          <strong>Right to delete.</strong> The right to have your personal
          information deleted without undue delay in certain circumstances, such
          as where the personal information is no longer necessary in relation
          to the purposes for which it was collected or processed.
        </li>
        <li>
          <strong>Right to restriction.</strong> The right to obtain the
          restriction of the processing undertaken by us on your personal
          information in certain circumstances, such as where the accuracy of
          the personal information is contested by you, for a period enabling us
          to verify the accuracy of that personal information.
        </li>
        <li>
          <strong>Right to object.</strong> The right to object, on grounds
          relating to your particular situation, to the processing of your
          personal information, and to object to processing of your personal
          information for direct marketing purposes, to the extent it is related
          to such direct marketing.
        </li>
      </ul>
      <p>
        If you wish to exercise one of these rights, please contact us using the
        contact details at the end of this privacy policy or provided with the
        Data Hub. Upon request, we will provide you with information about
        whether we hold any of your personal information. You may access,
        correct or request deletion of your personal information and we will
        respond to your request as soon as we are able.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>CHOICES AND ACCESS TO INFORMATION</h2>
      <p>
        You may send us an email at info&#64;accdata.org to request access to or
        correct any personal information that you have provided to us. We may
        not accommodate a request to change information if we believe the change
        would violate any law or legal requirement or cause the information to
        be incorrect.
      </p>
      <p>
        You can have your information deleted and/or remove your information
        from the Data Hub by notifying the Company of such request at
        unsubscribe&#64;accdata.org.
      </p>
      <p>
        The help portion of the toolbar on most browsers will tell you how to
        prevent your browser from accepting new cookies, how to have the browser
        notify you when you receive a new cookie, or how to disable cookies
        altogether.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>LINKS TO THIRD PARTY WEBSITES</h2>
      <p>
        The Data Hub may, from time to time, contain links to and from other
        websites. If you follow a link to any of these websites, please note
        that these websites have their own privacy policies, and ACC does not
        accept any responsibility or liability for their policies or for the
        content. ACC encourages its users to be aware when they leave the Data
        Hub and to read the privacy statements of each website they visit.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>TERMS OF USE, NOTICE AND REVISIONS</h2>
      <p>
        Your use of the Data Hub, and any disputes arising from it, is subject
        to this Privacy Policy. We reserve the right to change our Privacy
        Policy at any time. All changes are effective immediately when we post
        them, and apply to all access to and use of ACC's Data Hub thereafter.
        Your continued use of the Data Hub following the posting of a revised
        Privacy Policy means that you accept and agree to the changes. We
        encourage you to refer to this page on an ongoing basis so that you are
        aware of and understand our current Privacy Policy. Unless stated
        otherwise, the current Privacy Policy applies to all information that we
        have about you and your account.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>NOTICE TO YOU</h2>
      <p>
        If we need to provide you with information about something, whether for
        legal, marketing or other business-related purposes, we will select what
        we believe is the best way to get in contact with you. We will usually
        do this through email or by placing a notice on our website. The fact
        that we may send notices to you will not stop you from being able to opt
        out of certain types of contact as described in this Privacy Policy.
      </p>
    </div>

    <div class="privacy-policy__section">
      <h2>CONTACT INFORMATION</h2>
      <p>
        To report any violations of this Privacy Policy or if you have any
        questions or comments about this Privacy Policy, you may contact us at
        info&#64;accdata.org.
      </p>
    </div>
  </div>
</div>
